import constants from "../utils/Constants";
import { getData, postData, putData } from "./rest-api-helper"


export async function getComDashServ({ userType, limit, pageNumber, searchKeyWord, searchKeyType }) {
    let urlPath;

    if (userType === constants.lineManager)
        urlPath = `/dashboard/lineManager`;
    else if (userType === constants.focalPoint)
        urlPath = `/dashboard/focalPoint`;
    else if (userType === constants.approver)
        urlPath = `/dashboard/approver`;
    else
        urlPath = `/dashboard/requestor`;
    console.log({ userType, limit, pageNumber, searchKeyWord, searchKeyType })

    const details = {
        urlPath: urlPath,
        queryParams: {
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(searchKeyType && { searchType: searchKeyType }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit })
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getUserProfile({ userId, isComUser }) {
    const comDet = {
        urlPath: `/company/user/myProfile`
    }
    const amtcDet = {
        urlPath: `/amtc/userProfile`,
        queryParams: {
            userId
        }
    }
    const res = await getData(isComUser ? comDet : amtcDet);
    return res.data;
}

export async function getComListServ() {
    const comDet = {
        urlPath: `/company`
    }
    const res = await getData(comDet);
    return res.data.length === 0 ? [] : res.data;
}

export async function getPotListServ({ comId, limit, pageNumber, searchKeyWord, searchKeyType }) {
    console.log({searchKeyWord})
    const details = {
        urlPath: "/pot",
        queryParams: {
            ...(comId && { comId }),
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(searchKeyType && { searchType: searchKeyType }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit })
        }
    }
    const res = await getData(details);
    return res.data;
}


export async function addPoServ(data) {
    const details = {
        urlPath: "/pot/add",
        body: {
            ...data
        }
    }

    const res = await postData(details);
    return res;
}

export async function getSinglePOServ(poId) {
    const details = {
        urlPath: `/pot/single/${poId}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editPoServ(data, poId) {
    const details = {
        urlPath: `/pot/edit/${poId}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getSingleComServ(comId) {
    const details = {
        urlPath: `/company/single/${comId}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editComPotProjDetServ(data) {
    const details = {
        urlPath: `/pot/editComPotProjDet`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function editPoProdClientRemarkServ(data) {
    const details = {
        urlPath: `/pot/editPoProdClientRemark`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getSinglePoProdServ(poProdId) {
    const details = {
        urlPath: `/pot/getSinglePoProd/${poProdId}`
    }
    const res = await getData(details);
    return res.data;
}

export async function editDoInvServ(data) {
    const details = {
        urlPath: `/pot/editDoInv`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}